<template>
  <div class="c-indicator-style">
    <el-collapse>
      <el-collapse-item title="快捷布局">
        <el-form-item>
          <div class="carousel-select-item">
            <div class="arrows left-arrow">
              <!-- <div class="arrow-icon-container" :class="{ disabled:  true || currentPage === 0 }" @click="prevPage">
                <i class="el-icon-arrow-left"></i>
              </div> -->
            </div>
            <div class="carousel-select-group" ref="carouselGroup">
              <div class="carousel-content">
                <div class="carousel-select-group-item" v-for="i in [1,2,6]" :key="i"
                  :class="{ 'selected': selectItem.styleConfig.commongConfig.indicatorStyle === i }"
                  @click="selectLayout(i)">
                  <img :src="require(`@/assets/img/dashboard/lay${i}.png`)" alt="">
                </div>
              </div>
            </div>
            <div class="arrows right-arrow">
              <!-- <div class="arrow-icon-container" :class="{ disabled: true || currentPage === totalPages - 1 }" @click="nextPage">
                <i class="el-icon-arrow-right"></i>
              </div> -->
            </div>
          </div>
          <div class="slick-dots slick-dots-bottom" @click.prevent.stop v-if="false">
            <li v-for="(page, index) in totalPages" :key="index" :class="{ 'slick-active': currentPage === index }">
              <button></button>
            </li>
          </div>
        </el-form-item>
      </el-collapse-item>
      <el-collapse-item title="指标内容">
        <style-sub-item>
          <el-form-item>
            <div class="chart-form-item-warp">
              <span class="jz-chart-title-label">指标修饰</span>
              <el-switch v-model="selectItem.styleConfig.commongConfig.indicatorIcon">
              </el-switch>
            </div>
            <div class="c-indicator-item-list">
              <div class="c-indicator-item" v-for="(item, idx) in dataList" :key="idx">
                <span>{{ item }}</span>
                <div class="c-dimension-icon" @click="openIconSelector(item)">
                  <i :class="getIconForItem(item)"></i>
                </div>
              </div>
            </div>
          </el-form-item>
        </style-sub-item>
      </el-collapse-item>
    </el-collapse>

    <!-- 图标选择弹窗 -->
    <el-dialog size="mini" title="选择图标" :visible.sync="iconSelectorVisible" width="800px"
    append-to-body
      :before-close="closeIconSelector" class="icon-selector-dialog" :close-on-click-modal="false"
      :close-on-press-escape="false">
      <div class="icon-category-list">
        <div class="icon-category-wrapper" v-for="(category, categoryKey) in iconCategories" :key="categoryKey">
          <div class="icon-category-title">{{ category.title }}</div>
          <div class="icon-grid">
            <div v-for="icon in category.icons" :key="icon" class="icon-item"
              :class="{ 'icon-item-active': selectedIcon === icon }" @click="selectIcon(icon)">
              <i :class="icon"></i>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <div class="footer-buttons">
          <el-button size="mini" @click="closeIconSelector" class="cancel-btn">取消</el-button>
          <el-button size="mini" type="primary" @click="confirmIconSelection" class="confirm-btn">确定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import styleSubItem from '../base/styleSubItem.vue'
import icons, { elementIcons } from '../../utils/elementIcons'
import { formatIndicatorData, getCategoryDimension } from '../../utils/index'

export default {
  name: 'cIndicatorStyle',
  components: {
    styleSubItem
  },
  props: {
    selectItem: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      iconList: [...icons.allIcons, ...icons.commonIcons],
      styleConfig: {},
      currentPage: 0, // 当前页码
      itemsPerPage: 6, // 每页显示6个图片
      totalItems: 8, // 总共8张图片
      selectedLayout: null, // 当前选中的布局
      isTransitioning: false, // 是否正在切换中
      iconSelectorVisible: false, // 图标选择弹窗显示状态
      currentEditingIndex: -1, // 当前编辑的指标索引
      selectedIcon: '', // 当前选中的图标
      iconCategories: {
        basic: {
          title: '基础图标',
          icons: [
            'el-icon-info', 'el-icon-menu', 'el-icon-share', 'el-icon-d-caret', 'el-icon-caret-left',
            'el-icon-caret-right', 'el-icon-caret-bottom', 'el-icon-caret-top', 'el-icon-bottom-left',
            'el-icon-bottom-right', 'el-icon-back', 'el-icon-right', 'el-icon-bottom', 'el-icon-top',
            'el-icon-top-left', 'el-icon-top-right', 'el-icon-s-help', 'el-icon-s-operation', 'el-icon-s-platform'
          ]
        },
        actions: {
          title: '操作图标',
          icons: [
            'el-icon-plus', 'el-icon-minus', 'el-icon-edit', 'el-icon-edit-outline', 'el-icon-view',
            'el-icon-refresh', 'el-icon-refresh-right', 'el-icon-refresh-left', 'el-icon-finished',
            'el-icon-sort', 'el-icon-sort-up', 'el-icon-sort-down', 'el-icon-rank', 'el-icon-c-scale-to-original',
            'el-icon-date', 'el-icon-search', 'el-icon-monitor', 'el-icon-attract', 'el-icon-mobile', 'el-icon-scissors'
          ]
        },
        navigation: {
          title: '导航图标',
          icons: [
            'el-icon-arrow-left', 'el-icon-arrow-right', 'el-icon-arrow-down', 'el-icon-arrow-up',
            'el-icon-d-arrow-left', 'el-icon-d-arrow-right'
          ]
        },
        status: {
          title: '状态图标',
          icons: [
            'el-icon-success', 'el-icon-error', 'el-icon-warning', 'el-icon-info', 'el-icon-question',
            'el-icon-loading', 'el-icon-check', 'el-icon-close', 'el-icon-remove', 'el-icon-circle-plus',
            'el-icon-circle-close', 'el-icon-remove-outline', 'el-icon-circle-plus-outline'
          ]
        },
        charts: {
          title: '数据图表',
          icons: [
            'el-icon-pie-chart', 'el-icon-data-line', 'el-icon-data-board', 'el-icon-data-analysis',
            'el-icon-s-data', 'el-icon-s-grid', 'el-icon-s-check', 'el-icon-s-flag', 'el-icon-s-marketing',
            'el-icon-s-finance', 'el-icon-s-opportunity', 'el-icon-s-claim', 'el-icon-s-custom', 'el-icon-s-comment',
            'el-icon-s-ticket', 'el-icon-s-management', 'el-icon-s-open', 'el-icon-s-shop', 'el-icon-s-promotion',
            'el-icon-s-home'
          ]
        },
        files: {
          title: '文件图标',
          icons: [
            'el-icon-document', 'el-icon-document-add', 'el-icon-document-remove', 'el-icon-document-delete',
            'el-icon-document-copy', 'el-icon-document-checked', 'el-icon-folder', 'el-icon-folder-opened',
            'el-icon-folder-add', 'el-icon-folder-remove', 'el-icon-folder-delete', 'el-icon-folder-checked',
            'el-icon-files', 'el-icon-tickets', 'el-icon-paperclip', 'el-icon-printer'
          ]
        }
      }
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalItems / this.itemsPerPage)
    },
    // 当前页显示的图片范围
    currentPageItems() {
      const start = this.currentPage * this.itemsPerPage
      const end = Math.min(start + this.itemsPerPage, this.totalItems)
      return Array.from({ length: end - start }, (_, i) => start + i + 1)
    },
    dataList() {
      const {
        data: {
          data: chartData,
        },
      } = this.selectItem
      
      // 如果没有初始化图标映射，则初始化一次
      if (!this.selectItem?.styleConfig?.helperData?.indicatorRowIconMap) {
        this.$set(this.selectItem.styleConfig.helperData, 'indicatorRowIconMap', {})
      }
      

      const rowValues = formatIndicatorData(this.selectItem.fields, chartData).map(item => item.rowValue || item.measureName).filter(item => !!item)
      // 为每个 rowValue 初始化图标（如果还没有的话）
      rowValues.forEach(rowValue => {
        if (!this.selectItem?.styleConfig?.helperData?.indicatorRowIconMap[rowValue]) {
          const randomIndex = Math.floor(Math.random() * this.iconList.length)
          this.$set(this.selectItem.styleConfig.helperData.indicatorRowIconMap, rowValue, this.iconList[randomIndex])
        }
      })
      console.log('rowValues:',rowValues,this.selectItem.styleConfig.helperData.indicatorRowIconMap)
      return rowValues
    }
  },
  methods: {
    // 上一页
    prevPage() {
      if (this.currentPage > 0 && !this.isTransitioning) {
        this.switchPage(this.currentPage - 1)
      }
    },

    // 下一页
    nextPage() {
      if (this.currentPage < this.totalPages - 1 && !this.isTransitioning) {
        this.switchPage(this.currentPage + 1)
      }
    },

    // 跳转到指定页
    goToPage(pageIndex) {
      if (pageIndex >= 0 && pageIndex < this.totalPages && !this.isTransitioning) {
        this.switchPage(pageIndex)
      }
    },

    // 平滑切换页面
    switchPage(newPage) {
      this.isTransitioning = true

      // 直接切换页面，让CSS transition处理动画
      this.currentPage = newPage

      // 短暂延迟后重置状态
      this.$nextTick(() => {
        setTimeout(() => {
          this.isTransitioning = false
        }, 50)
      })
    },

    // 选择布局
    selectLayout(layoutIndex) {
      // 设置选中的布局
      this.$set(this.selectItem.styleConfig.commongConfig, 'indicatorStyle', layoutIndex)
      this.$emit('layoutSelect', layoutIndex)
    },

    // 获取指标对应的图标
    getIconForItem(rowName) {
      if (this.selectItem.styleConfig.helperData.indicatorRowIconMap[rowName]) {
        return this.selectItem.styleConfig.helperData.indicatorRowIconMap[rowName]
      }
      // 如果没有设置图标，返回随机图标
      const randomIndex = Math.floor(Math.random() * this.iconList.length)
      return this.iconList[randomIndex]
    },

    // 打开图标选择器
    openIconSelector(rowName) {
      this.currentEditingIndex = rowName
      this.selectedIcon = this.selectItem.styleConfig.helperData.indicatorRowIconMap[rowName] || ''
      this.iconSelectorVisible = true
    },

    // 选择图标
    selectIcon(icon) {
      this.selectedIcon = icon
    },

    // 确认图标选择
    confirmIconSelection() {
      this.$set(this.selectItem.styleConfig.helperData.indicatorRowIconMap, this.currentEditingIndex, this.selectedIcon)
      this.closeIconSelector()
    },

    // 关闭图标选择器
    closeIconSelector() {
      this.iconSelectorVisible = false
      this.currentEditingIndex = -1
      this.selectedIcon = ''
    },

  }
}
</script>
<style scoped lang="less">
.c-indicator-style {
  .c-indicator-item-list {
    background-color: #fff;
    margin-top: 12px;
    padding: 6px 0;

    .c-indicator-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 32px;
      line-height: 32px;
      padding: 0 12px;
    }

    .c-dimension-icon {
      border: 1px solid rgba(255, 255, 255, 0.15);
      border-radius: 4px;
      width: 40px;
      height: 24px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.2s ease;

      &:hover {
        border-color: var(bi-jz-primary-color);
        background-color: rgba(64, 158, 255, 0.1);
      }

      i {
        font-size: 16px;
        color: var(--bi-jz-font-color);
      }
    }
  }

  .carousel-select-item {
    display: flex;
    // height: 110px;
  }

  .arrows {
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 100%;
    display: flex;

    .arrow-icon-container {
      cursor: pointer;
      background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, .1) 8%);
      border: 1px solid rgba(151, 151, 151, .1);
      border-radius: 8.5px;
      justify-content: center;
      align-items: center;
      width: 12px;
      height: 34px;
      display: flex;
      box-shadow: -2px 0 4px rgba(59, 57, 57, .1);
    }

    .arrow-icon-container.disabled {
      box-shadow: none;
      cursor: not-allowed;
      border: none;
    }
  }

  .carousel-select-group {
    flex: 1;
    gap: 2px;
    padding: 2px;
    position: relative;
  }

  .carousel-content {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2px;
    transition: all 0.2s ease-out;
  }

  .carousel-select-group-item {
    transition: all 0.2s ease;
    position: relative;
    border-radius: 4px;
    overflow: hidden;
    border: 2px solid transparent; // 给所有item添加透明边框，保持布局一致

    &:hover {
      transform: scale(1.05);
    }

    &.selected {
      border: 2px solid var(bi-jz-primary-color);
      box-shadow: 0 0 8px rgba(64, 158, 255, 0.4);
      transform: scale(1.02);

      &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(64, 158, 255, 0.1);
        pointer-events: none;
      }
    }

    img {
      display: block;
      cursor: pointer;
      border-radius: 2px;
      width: 50px;
      height: 40px;
      transition: all 0.2s ease;
    }
  }

  .slick-dots {
    z-index: 15;
    justify-content: center;
    margin-bottom: 0;
    margin-left: 15%;
    margin-right: 15%;
    padding-left: 0;
    list-style: none;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex !important;

    li {
      box-sizing: content-box;
      width: var(--bi-carousel-dot-width, 16px);
      height: var(--bi-carousel-dot-height, 3px);
      text-align: center;
      text-indent: -999px;
      vertical-align: top;
      flex: 0 auto;
      margin: 0 4px;
      padding: 0;
      transition: all .5s;
      display: inline-block;
      position: relative;
      cursor: pointer;
    }
  }

  .slick-dots li.slick-active {
    width: var(--bi-carousel-dot-width, 24px);
  }

  .slick-dots li button {
    width: 100%;
    height: var(--bi-carousel-dot-height, 3px);
    color: transparent;
    background: var(--bi-component-background, #fff);
    cursor: pointer;
    opacity: .3;
    border: 0;
    border-radius: 1px;
    outline: none;
    padding: 0;
    font-size: 0;
    transition: all .5s;
    display: block;
    position: relative;
  }

  .slick-dots.slick-dots-bottom {
    z-index: 1;
    margin-bottom: 0;
    bottom: 0;
  }

  .slick-dots.slick-dots-bottom li.slick-active button {
    opacity: 1;
  }

  .slick-dots.slick-dots-bottom li button {
    background-color: rgba(255, 255, 255, 0.75);
  }

  .slick-dots li button:after {
    content: "";
    position: absolute;
    top: -4px;
    bottom: -4px;
    left: -4px;
    right: -4px;
  }
}

// 图标选择弹窗样式 - 暗黑主题
.icon-selector-dialog {
  /deep/ .el-dialog {
    background-color: var(--bi-jz-input-bg-color);
    border: 1px solid var(--bi-jz-input-border-color);
    border-radius: 12px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
  }

  /deep/ .el-dialog__header {
    background-color: var(--bi-jz-input-bg-color);
    border-bottom: 1px solid var(--bi-jz-input-border-color) !important;
    padding: 20px 24px 16px;
    border-radius: 12px 12px 0 0;
  }

  /deep/ .el-dialog__title {
    color: var(--bi-jz-font-color);
    font-size: 18px;
    font-weight: 600;
  }

  /deep/ .el-dialog__headerbtn {
    top: 20px;
    right: 24px;
  }

  /deep/ .el-dialog__close {
    color: var(--bi-jz-font-color);
    font-size: 20px;
    
    &:hover {
      color: var(--bi-jz-font-color);
    }
  }

  /deep/ .el-dialog__body {
    background-color: var(--bi-jz-input-bg-color);
    padding: 20px 24px;
    overflow: visible;
    max-height: 510px;
    border-top:1px solid var(--bi-jz-input-border-color) !important;
    border-bottom: 1px solid var(--bi-jz-input-border-color) !important;
  }

  /deep/ .el-dialog__footer {
    background-color: var(--bi-jz-input-bg-color);
    border-top: 1px solid var(--bi-jz-input-border-color) !important;
    padding: 16px 24px 20px;
    border-radius: 0 0 12px 12px;
  }

  .icon-category-list {
    max-height: 480px;
    overflow-y: auto;
    
    .icon-category-wrapper {
      margin-bottom: 24px;
      
      .icon-category-title {
        font-size: 16px;
        font-weight: 600;
        color: #ffffff;
        margin-bottom: 12px;
        padding-bottom: 8px;
        border-bottom: 1px solid #F7F7F7;
      }
      
      .icon-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(60px, 1fr));
        gap: 12px;
        
        .icon-item {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 60px;
          height: 60px;
          border: 1px solid #F7F7F7;
          border-radius: 8px;
          cursor: pointer;
          transition: all 0.2s ease;
          background-color: #F7F7F7;
          
          &:hover {
            border-color: var(bi-jz-primary-color);
            background-color: #1a3a5c;
            transform: scale(1.05);
            box-shadow: 0 4px 12px rgba(64, 158, 255, 0.2);
          }
          
          &.icon-item-active {
            border-color: var(bi-jz-primary-color);
            background-color: #1a3a5c;
            box-shadow: 0 0 12px rgba(64, 158, 255, 0.4);
            transform: scale(1.02);
          }
          
          i {
            font-size: 24px;
            color: #cccccc;
            transition: color 0.2s ease;
          }
          
          &:hover i,
          &.icon-item-active i {
            color: var(bi-jz-primary-color);
          }
        }
      }
    }
  }

  .dialog-footer {
    .footer-buttons {
      display: flex;
      justify-content: flex-end;
      gap: 12px;
      
      .cancel-btn {
        background-color: #F7F7F7;
        border-color: #F7F7F7;
        color: #cccccc;
        border-radius: 6px;
        font-weight: 500;
        transition: all 0.2s ease;
        width: 80px;
        
        &:hover {
          background-color: #505050;
          border-color: #505050;
          color: #ffffff;
        }
      }
      
      .confirm-btn {
        background-color: var(bi-jz-primary-color);
        border-color: var(bi-jz-primary-color);
        color: #ffffff;
        border-radius: 6px;
        font-weight: 500;
        transition: all 0.2s ease;
        width: 80px;
        
        &:hover {
          background-color: #66b1ff;
          border-color: #66b1ff;
        }
        
        &:active {
          background-color: #3a8ee6;
          border-color: #3a8ee6;
        }
      }
    }
  }
}
</style>
